import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const LogoBox = styled(Box)({
  width: 215,
  maxHeight: 56,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '8px 4px',
  '& img': {
    maxWidth: '100%',
    maxHeight: 32,
    objectFit: 'contain',
  },
});

interface SideMenuLogoProps {
  collapsed?: boolean;
}

export default function SideMenuLogo({ collapsed = false }: SideMenuLogoProps) {
  return (
    <LogoBox
      sx={
        collapsed
          ? {
              width: 44,
              minWidth: 44,
              maxHeight: 44,
              minHeight: 44,
              padding: '6px',
              '& img': {
                maxWidth: 32,
                maxHeight: 32,
                width: 32,
                height: 32,
                objectFit: 'contain',
              },
            }
          : undefined
      }
    >
      <img
        src={collapsed ? '/favicon.ico' : '/Empirefx_logo_white.png'}
        alt="Empire FX"
      />
    </LogoBox>
  );
}
